
// Menu Trigger
var menuTrigger = document.querySelector('.navigation__menu-trigger');
var header = document.querySelector('.js-navigation');

menuTrigger.onclick = function () {
  header.classList.toggle('menu-open');
};



